export enum TipoBoleto {

    PREVIDENCIA = 1,
    SAUDE,
    PECULIO,

}
